<div [id]="popupModel().id" class="popup w-100 {{ size() }}" style="overflow-y: auto">
  <div
    [ngClass]="popupModel().componentData?.iconColorClass ? popupModel().componentData?.iconColorClass : 'blue'"
    class="button small text-white"
    style="pointer-events: none"
  >
    <i [className]="popupModel().componentData?.iconTypeClass" aria-hidden="true" class="far"></i>
  </div>
  <div class="popup-inner">
    <h1 data-test="kgu-popup-title" id="kgu_ummeldung_save_popup-title" class="h3">{{ popupModel().titleKey | translate }}</h1>
    @if (popupModel().componentData?.messageKey) {
      <p [innerHTML]="popupModel().componentData?.messageKey | translate" data-test="popup-message" tabindex="-1"></p>
    }
    <div tabindex="0" class="screen-hidden">
      <!-- This element is required to control focus when the popup opens and to ensure that no other interactive element is automatically focused. -->
    </div>
    <div class="my-3">
      <mwe-button
        id="submitAddUserButton"
        buttonType="submit"
        class="btn-container d-block"
        category="primary"
        labelKey="ummeldung.confirmExitPopup.button.saveAndClose"
        (clicked)="submit()"
      />
    </div>
    <div class="my-3">
      <mwe-button
        id="closeWithoutSavingButton"
        buttonType="submit"
        class="btn-container d-block"
        category="secondary"
        labelKey="ummeldung.confirmExitPopup.button.closeWithoutSaving"
        (clicked)="closeWithoutSaving()"
      />
    </div>
    <div class="mt-3">
      <mwe-button-link
        id="cancelButton"
        label="ummeldung.confirmExitPopup.button.cancel"
        class="d-block w-md-auto text-no-underline py-3"
        (clicked)="cancelPopup()"
      />
    </div>
  </div>
</div>
